// CSS Modules - component class name prefix: Configurator__

<template>
  <div :class="$style.container">
    <div :class="$style.hint">
      <strong>{{ config.hintLabel }}</strong>
      <span>{{ config.hintText }}</span>
    </div>
    <div
      v-if="config.modelcodes.length > 1"
      :class="[$style.radios, 'columns', 'is-multiline']"
    >
      <div :class="['column', 'is-full']">
        <strong>{{ config.pleaseChooseText }}</strong>
      </div>
      <div
        v-for="(code, index) in config.modelcodes"
        :key="code"
        :class="['column', 'is-half']"
      >
        <div :class="$style.radio">
          <span>
            <input
              type="radio"
              :class="$style.orderDataItem"
              :id="'modelcode' + index"
              v-bind:value="code"
              v-model="config.modeloritemid"
              v-on:change="init(config)"
              name="modelcode"
            />
            <label :for="'modelcode' + index">
              {{ config.additionalTexts[index] }}
            </label>
          </span>
        </div>
      </div>
    </div>
    <div :class="$style.app"></div>
  </div>
</template>

<script>
import CustomEvents from "../../globals/constants/customEvents";
import getQuoteIdFromUrl from "../../xhr/shopCart/getQuoteIdFromUrl";
import addItemToUrl from "../../xhr/shopCart/addItemToUrl";

export default {
  name: "Configurator",
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    shopConfig: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    init(localConfig) {
      // Online-Shop
      window.onWebConfiguratorClosedOkToShop = data => {
        if (isShopPageAvailable) {
          let articleID = "";
          if (!data.ItemInformation.Item.IsOrmigNumber) {
            articleID = data.ItemInformation.Item.ItemId;
          }
          window.location.href =
            localConfig.shopUrl +
            (articleID !== "" ? "?article=" + articleID : "");
        }
      };
      // Finished configuration
      window.onWebConfiguratorClosedOk = data => {
        const deliveryTime = parseInt(
          data.ItemInformation.DeliveryInformation.DeliveryTime,
          10
        );
        const externalTransport = parseInt(
          data.ItemInformation.DeliveryInformation.ExternalTransport,
          10
        );
        const deliveryTimeSum =
          (isNaN(deliveryTime) ? 0 : deliveryTime) +
          (isNaN(externalTransport) ? 0 : externalTransport);

        getQuoteIdFromUrl(window.getQuoteIdUrl)
          .then(quoteId => {
            addItemToUrl(window.addItemUrl, {
              itemid: data.ItemInformation.Item.ItemId,
              quantity: 1,
              country: window.currentCountry,
              language: window.currentLanguage,
              quoteid: quoteId,
              headline: this.shopConfig.headline,
              subheadline: this.shopConfig.subheadline,
              pictureurl: this.shopConfig.pictureurl,
              thumbnailurl: this.shopConfig.thumbnailurl,
              producturl: this.shopConfig.producturl,
              btype: data.ItemInformation.ModelcodeObj.map(
                codeObjItem => codeObjItem.TypeObject.CodeType
              ),
              codestring: data.ItemInformation.ModelcodeObj.map(
                codeObjItem => codeObjItem.TypeObject.CodeString
              ),
              price: data.ItemInformation.Pricing.NetPrice,
              priceSum: data.ItemInformation.Pricing.PositionPrice,
              priceInstanceSum: data.ItemInformation.Pricing.PositionPrice,
              grossPrice: data.ItemInformation.Pricing.GrossPrice,
              grossPriceUnit: data.ItemInformation.Pricing.GrossPriceUnit,
              deliveryTime: deliveryTimeSum,
              deliveryCategory:
                data.ItemInformation.DeliveryInformation.DeliveryCategoryInt
            })
              .then(response => {
                const event = new CustomEvent(CustomEvents.ADD_TO_CART, {
                  detail: response.data
                });
                window.dispatchEvent(event);
                this.$emit("closed");
              })
              .catch(error => {
                console.error(error);
              });
          })
          .catch(error => {
            console.error(error);
          });
      };
      // Find similar products
      window.onWebConfiguratorClosedOkToWebform = function(data) {
        let codes = data.CurrentState.CurrentCoding;
        let codeStrings = "";
        let codeNames = "";
        let c = 0;
        for (c = 0; c < codes.length; c++) {
          if (c != codes.length - 1) {
            codeStrings += codes[c].ContentString + ",";
            codeNames += codes[c].CodeTypeName + ",";
          } else {
            codeStrings += codes[c].ContentString;
            codeNames += codes[c].CodeTypeName;
          }
        }
        let codeQueryString =
          "?codeNames=" + codeNames + "&codes=" + codeStrings;
        let articleID = "";
        if (!data.ItemInformation.Item.IsOrmigNumber) {
          articleID = data.ItemInformation.Item.ItemId;
          const event = new CustomEvent(CustomEvents.ADD_TO_LOCAL_STORAGE, {
            detail: {
              id: articleID,
              detailText: data.CurrentState.CurrentDescriptionLong
            }
          });
          window.dispatchEvent(event);
          window.location.href =
            localConfig.orderFormUrl +
            codeQueryString +
            "&article=" +
            articleID;
        } else {
          window.location.href = localConfig.orderFormUrl + codeQueryString;
        }
      };
      // Initialize configurator
      window.WikaProdConf.initProduktConfigurator(
        {
          containerselector: ".Configurator__app",
          baseUrl: localConfig.baseUrl,
          optionGraphicSettings: {
            enabled: true,
            publicShareBaseUrl: localConfig.publicShareBaseUrl
          },
          webservice_url: localConfig.webservice_url,
          language: localConfig.language,
          loginname: localConfig.loginname,
          websessionid: localConfig.websessionid,
          plannumber: localConfig.plannumber,
          maxRangeQuantity: localConfig.maxRangeQuantity,

          showtypecode: localConfig.showtypecode,
          showtexts: localConfig.showtexts,
          showadminwidget: localConfig.showadminwidget,

          visualmode: localConfig.visualmode,
          showIbDLink: localConfig.showIbDLink,
          disableExtBtn1: !window.shopAvailable || instance === "shop",
          allowincomplete: localConfig.allowincomplete,
          hastagnumbers: localConfig.hastagnumbers,
          allowcodechange: localConfig.allowcodechange,
          modeloritemid: localConfig.modeloritemid,
          modelcodeobj: localConfig.modelcodeobj,
          button_definitions: [
            {
              text: "resume",
              className: "primary",
              disabledWhileIncomplete: true,
              onClick: function(app) {
                var res = app.getResults();
                res
                  .then(function(data) {
                    window.onWebConfiguratorClosedOk(data);
                  })
                  .fail((error, data) => console.error(error, data));
              }
            }
          ]
        },
        true
      );
    },
    getParameter(param) {
      var params = window.location.search.substr(1).split("&");

      for (var i = 0; i < params.length; i++) {
        var p = params[i].split("=");
        if (p[0] == param) {
          return decodeURIComponent(p[1]);
        }
      }
      return false;
    },
    handleInitWithWikaProdConf() {
      if (window.WikaProdConf) {
        this.init(this.config);
      } else {
        const timeoutForWikaProdConf = setTimeout(() => {
          this.handleInitWithWikaProdConf();
          clearTimeout(timeoutForWikaProdConf);
        }, 500);
      }
    }
  },
  mounted() {
    // Check if a code/configuratin is provided by url
    let initByCode = false;
    let codeString = this.getParameter("confPreset");
    if (codeString) {
      initByCode = true;
      let codeType = this.getParameter("codeType");
      this.config.modelcodeobj = [
        {
          TypeObject: {
            CodeType: codeType || "",
            CodeString: codeString
          }
        }
      ];
    }

    // Check if multiple modelcodes were provided - if not initialize directly
    if (this.config.modelcodes.length == 1 || initByCode) {
      this.config.modeloritemid = initByCode ? "" : this.config.modelcodes[0];
      this.handleInitWithWikaProdConf();
    }
  }
};
</script>

<style module lang="scss">
@import "./Configurator.scss";
</style>
